export default __webpack_public_path__ + "903fd9bd5f8de5c1e9119b19851f74fd.svg";